const listOverrides = {
  styleOverrides: {
    root: {
      padding: 0,
    },
  },
};

export default listOverrides;
